import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.termsOfUseModal.title',
    defaultMessage: 'Terms of Use',
  },
  back: {
    id: 'simulated.termsOfUseModal.back',
    defaultMessage: 'Back',
  },
  agreeAndContinue: {
    id: 'simulated.termsOfUseModal.agreeAndContinue',
    defaultMessage: 'Agree and Continue',
  },
  manuallyLoad: {
    id: 'simulated.termsOfUseModal.manuallyLoad',
    defaultMessage: 'Manually Load',
  },
});
